import { render } from "./FormularioAtendimento.vue?vue&type=template&id=4ebc8fce"
import script from "./FormularioAtendimento.vue?vue&type=script&lang=js"
export * from "./FormularioAtendimento.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__